export default "/images/serialCart.svg?78517a7f5c77ac3557df96ec314c74a5";